class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.elements = {
      modalTrigger: document.querySelector('[data-localization-form-modal-trigger]'),
      modalClose: document.querySelector('[data-localization-form-close]'),
      modal: document.querySelector('[data-localization-form-modal')
    }

    this.elements.modalTrigger.addEventListener('click', this.openModal.bind(this))
    this.elements.modalClose.addEventListener('click', this.closeModal.bind(this))
    this.elements.modal.addEventListener('click', this.detectOutsideClick.bind(this))
  }

  openModal() {
    this.elements.modal.classList.add('open')
    document.addEventListener('keyup', this.handleEsc.bind(this))
    const select = this.querySelector('.select_wrapper')
    select.tabIndex = 0
  }

  closeModal() {
    this.elements.modal.classList.remove('open')
    document.removeEventListener('keyup', this.handleEsc.bind(this))
    const select = this.querySelector('.select_wrapper')
    select.tabIndex = -1
  }

  detectOutsideClick(e) {
    const isOutside = !e.target.closest('.localization-form__modal-body')
    isOutside && this.closeModal()
  }

  handleEsc(e) {
    if (e.key === 'Escape') {
      this.closeModal()
    }
  }
}

customElements.define('localization-form', LocalizationForm)
